import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import { toggleImportModal, importCustomers } from '../../../../actions/customers';
import { IAppState } from '../../../../reducers/index';
import ImportModal from './ImportModal';

const mapStateToProps = ({ customers }: IAppState) => ({
  importing: customers.importing,
  importError: customers.importError,
});

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    toggleImportModal: () =>
      dispatch(toggleImportModal()),
    importCustomers: (file: File) =>
      dispatch(importCustomers.request({ file })),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ImportModal);